import type { ComponentProps } from "react";

import { toIsoDate } from "../date";
import { formatDateTime, useTranslation2 } from "../i18n";

type Props = Omit<ComponentProps<"time">, "dateTime"> & {
  dateTime: Date;
  format?: ((language: string, date: Date | number) => string) | undefined;
};

function Time({ dateTime, format = formatDateTime, children, ...props }: Props) {
  const {
    translation: {
      i18n: { language },
    },
  } = useTranslation2();

  return (
    <time dateTime={toIsoDate(dateTime)} {...props}>
      {children ?? format(language, dateTime)}
    </time>
  );
}

export { Time };
